module.exports = __webpack_public_path__ + "img/locked_crate.c904b416.png";